import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class HubspotSubmitterService {
  constructor(private httpClient: HttpClient) {}

  async subscribeToNewsletter(email: string) {
    const body: HubspotFormSubmissionBody = {
      fields: [
        {
          objectTypeId: '0-1',
          name: 'email',
          value: email
        }
      ],
      legalConsentOptions: {
        consent: {
          consentToProcess: true,
          text: 'I agree to allow RealWear to store and process my personal data.',
          communications: [
            {
              value: true,
              subscriptionTypeId: 999,
              text: 'I agree to receive marketing communications from RealWear.'
            }
          ]
        }
      }
    };

    try {
      const response = await firstValueFrom(
        this.httpClient.post(getSubmissionUrl('4426286', '9b499eba-db91-49fe-a517-4608de12e82d'), body, {
          observe: 'response'
        })
      );
      return response.ok;
    } catch {
      return false;
    }
  }
}

interface HubspotFormSubmissionBody {
  fields: HubspotFormSubmissionField[];
  context?: HubspotFormSubmissionContext;
  legalConsentOptions: HubspotFormSubmissionLegalConsentOptions;
}

interface HubspotFormSubmissionField {
  name: string;
  value: string;
  objectTypeId: '0-1';
}

interface HubspotFormSubmissionContext {
  pageUri: string;
  pageName: string;
}

interface HubspotFormSubmissionLegalConsentOptions {
  consent: HubspotFormSubmissionConsent;
}

interface HubspotFormSubmissionConsent {
  consentToProcess: boolean;
  text: string;
  communications: HubspotFormSubmissionCommunication[];
}

interface HubspotFormSubmissionCommunication {
  value: boolean;
  subscriptionTypeId: number;
  text: string;
}

function getSubmissionUrl(portalId: string, formGuid: string) {
  const url = 'https://api.hsforms.com/submissions/v3/integration/submit/:portalId/:formGuid';

  // Replace the placeholders with actual values
  const finalUrl = url.replace(':portalId', portalId).replace(':formGuid', formGuid);

  return finalUrl;
}
